import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ethers } from 'ethers';
import { BasePath } from '../../config/constants';
import NavbarLogo from '../../assets/logos/NavbarLogo';
import Button from '../../components/Button';
import { useWeb3React } from '@web3-react/core';
import { NavLink } from 'react-router-dom';
import { formatAccount } from '../../helpers';
import Sidebar from '../Sidebar';
import NavbarLogoSmall from '../../assets/logos/NavbarLogoSmall';
import clsx from 'clsx';
import ChainSelector from './ChainSelector';
import WalletDropdown from '../../modals/WalletDropdown';
import { ChevronIcon, TransactionSpinnerIcon, WalletIcon } from '../../assets/icons';
import useModalState from '../../context/modal/useModalState';
import useOrderListener from '../../hooks/web3/trade/useOrderListener';
import useTransactionState from '../../context/transaction/useTransactionState';

const navLinks = [
    {
        label: 'Trade',
        to: `${BasePath.TRADE}/BTCUSD`,
    },
    {
        label: 'Pools',
        to: BasePath.POOLS,
    },
    {
        label: 'Referrals',
        to: BasePath.REFERRALS,
    },
    {
        label: 'Analytics',
        to: BasePath.ANALYTICS,
    },
    {
        label: 'Leaderboard',
        to: BasePath.LEADERBOARD,
    },
];

const Header = () => {
    const { account } = useWeb3React();
    const { modal } = useModalState();

    const location = useLocation();
    const { pendingTransactions } = useTransactionState();
    useOrderListener();

    const [isSidebarOpen, setSidebarOpen] = useState(false);

    const openSidebar = (e: React.MouseEvent) => {
        e.stopPropagation();
        setSidebarOpen(true);
    };

    const closeSidebar = () => setSidebarOpen(false);

    return (
        <>
            <header>
                <div className='container'>
                    <Link className='logo-container' to={BasePath.HOME}>
                        <NavbarLogo />
                        <NavbarLogoSmall />
                    </Link>
                    <nav>
                        {navLinks.map(({ label, to }, index) => (
                            <NavLink
                                tabIndex={location.pathname === to ? -1 : 0}
                                key={index}
                                to={to}
                            >
                                {label}
                            </NavLink>
                        ))}
                    </nav>
                    <div className='buttons-container'>
                        <ChainSelector />
                        <WalletDropdown
                            trigger={
                                <Button
                                    className={clsx('connect-wallet', {
                                        connected: account,
                                        'dropdown-open': modal['walletDropdown'],
                                    })}
                                    variant='primary'
                                >
                                    {pendingTransactions.length ? (
                                        <>
                                            {pendingTransactions.length} Pending{' '}
                                            <TransactionSpinnerIcon />
                                        </>
                                    ) : (
                                        <>
                                            <WalletIcon />
                                            <span>
                                                {account ? (
                                                    formatAccount(
                                                        account ||
                                                            ethers.constants.AddressZero
                                                    )
                                                ) : (
                                                    <>
                                                        Connect <span>Wallet</span>
                                                    </>
                                                )}
                                            </span>
                                        </>
                                    )}
                                    {account && <ChevronIcon />}
                                </Button>
                            }
                        />
                        <Button className='menu-button' onClick={openSidebar}>
                            <span />
                            <span />
                            <span />
                        </Button>
                    </div>
                </div>
            </header>
            <Sidebar isOpen={isSidebarOpen} handleClose={closeSidebar} />
        </>
    );
};

export default Header;
